module.exports = __webpack_public_path__ + "static/404-9af2c8229ee8c5a957977faaf8d5a608.svg";